import {
  CapaQuotationRfqDetail,
  CapaQuotationUserBizType,
  CapaQuotationUserFile,
  CapaQuotationUserRfqDetail
} from '@generated/graphql';

export enum ActiveTabTypeEnum {
  DASHBOARD = 'dashboard',
  CHAT = 'chat',
  PROFILE = 'profile',
  EVENT = 'event',
  PAYMENT = 'payment'
}

export type ActiveTabType =
  | 'dashboard'
  | 'chat'
  | 'profile'
  | 'event'
  | 'payment';

export interface UserInfoData {
  id?: string;
  organizationName?: string;
  managerName?: string;
  email?: string;
  phoneNumber?: string;
  shortAddress?: string;
  bizType?: CapaQuotationUserBizType;
  companyIntroduction?: string;
  website?: string;
  files?: Array<CapaQuotationUserFile>;
}

export type RfqDetailData = Partial<
  CapaQuotationRfqDetail | CapaQuotationUserRfqDetail
>;

export interface IFile {
  fileId: string;
  fileName?: string | null;
  size?: number;
}
